import { MarkdownContent } from '../MarkdownContent'

interface QuestionCardProps {
  title: string
  content: string
}

export const QuestionCard = ({ title, content }: QuestionCardProps) => {
  return (
    <div className='relative flex flex-col items-center justify-center gap-2 bg-cool-50 px-8 py-6 text-center xs:rounded-lg'>
      <h3 className='font-body text-sm font-normal text-cool-600'>{title}</h3>

      <div className='text-center'>
        <MarkdownContent>{content}</MarkdownContent>
      </div>
    </div>
  )
}
